module.exports = __webpack_public_path__ + "components/weather-icon/static/dayrainshowers-a1c431a004104397a0bf8164e2a2b314.png";